/* src/app/main/premium-data/list/premium-data-list.component.scss */
:host ::ng-deep pageable-table td:nth-child(3) {
  white-space: pre-line;
  vertical-align: top;
}
/*# sourceMappingURL=premium-data-list.component-USQSKYIK.css.map */
